import contentType from 'content-type';

export const getErrorText = (errorObject, entityError) => {
  if (errorObject && entityError) {
    const entries = Object.entries(errorObject);
    if (entries) {
      for (let i = 0; i < entries.length; i++) {
        let entry = entries[i];
        if (entry.length >= 2) {
          var re = new RegExp(entry[0]);
          if (re.test(entityError.statusCode)) {
            return {
              statusCode: entityError.statusCode,
              message: entry[1]
            };
          }
        }
      }
    }
  }

  return entityError;

};

export const isEmptyString = (str) => {
  if (isUndefinedOrNull(str)) {
    return true;
  }
  if (str.length <= 0) {
    return true;
  }
  return false;
};

export const isUndefinedOrNull = (value) => {
  return value === null || value === undefined || typeof (value) === 'undefined';
};

export const isUndefined = (value) => {
  return value === undefined || typeof (value) === 'undefined';
};

export const isNull = (value) => {
  return value === null;
};

export const merge = (objects) => {
  let out = {};

  for (let i = 0; i < objects.length; i++) {
    for (let p in objects[i]) {
      out[p] = objects[i][p];
    }
  }

  return out;
};

export const flatten = (obj, name, stem) => {
  let out = {};
  //let newStem = (typeof stem !== 'undefined' && stem !== '') ? stem + '_' + name : name;
  let newStem = name;

  if (typeof obj !== 'object') {
    out[newStem] = obj;
    return out;
  }

  for (let p in obj) {
    let prop = flatten(obj[p], p, newStem);
    out = merge([out, prop]);
  }

  return out;
};

export const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};



export function reset(type) {
  return {
    type: type.RESET
  };
}


export function request(type) {
  return { type: type.REQUEST, error: false, isFetching: true };
}

export function receiveNoData(type) {
  return { type: type.NODATA, error: false, isFetching: false };
}

export function receive(type, payload) {
  return { type: type.SUCCESS, error: false, isFetching: false, payload: payload };
}

export function error(type, error) {
  return { type: type.FAILURE, isFetching: false, error };
}


export function handErrorV2(dispatch, payload, ACTION, callback = () => false){
  
}

export function handleError(dispatch, payload, ACTION, callback = () => false) {

  if (payload.status === 500) {
    let err = {
      statusCode: payload.status,
      message: "Unable to connect to server, please try again later."
    };
    dispatch(error(ACTION, err));
    return callback(err);
  } else {
    var obj = {};
    if (payload && payload.headers && payload.headers.get("Content-Type")) {
      obj = contentType.parse(payload.headers.get("Content-Type"));
    }
    if (obj.type === "application/json") {
      payload
        .json()
        .then(json => {
          let err = {
            statusCode: payload.status,
            message: json.message
          };
          dispatch(error(ACTION, err));
          callback(err);
        })
        .catch(err => {
          dispatch(error(ACTION, {
            statusCode: err.status || 0,
            message: err.message
          }));
          callback(err);
        });
    } else if (obj.type === "text/plain") {
      payload.text()
        .then(text => {
          let err = {
            statusCode: payload.status,
            message: text
          };
          dispatch(error(ACTION, err));
          callback(err);
        })
        .catch(err => {
          dispatch(error(ACTION, {
            statusCode: err.status || 0,
            message: err.message
          }));
          callback(err);
        });
    } else {
      let err = {
        statusCode: payload.status,
        message: payload.statusText
      };
      dispatch(error(ACTION, err));
      callback(err);
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/Utils.js